export enum Role {
  ADMIN = 'admin',
  MAHINDRA_ADMIN = 'mahindra_admin',
  ADVANCED_ADMIN = 'advanced_admin'
}
